import { helpVi } from "./help.vi";
export const languageVietnamese = {
    modelPresetToolUse: "Sử dụng công cụ",
    modelPresetToolUseHelp: "Cho phép preset này gọi các công cụ đã cấu hình (MCP). Mặc định tắt. Lượt chạy công cụ được gửi mà không có streaming.",
    "formating": {
        "main": "Lời nhắc chính",
        "jailbreak": "Lời nhắc bẻ khóa",
        "chats": "Cuộc trò chuyện trước đây",
        "lorebook": "Sách truyền thuyết",
        "globalNote": "Ghi chú chung",
        "authorNote": "Ghi chú của tác giả",
        "lastChat": "Cuộc trò chuyện cuối cùng",
        "description": "Mô tả nhân vật",
        "personaPrompt": "Lời nhắc của Persona",
        "plain": "Lời nhắc đơn giản",
        "memory": "Bộ nhớ Supa/Hypa",
        "postEverything": "End-Injected Prompts"
    },
    "errors": {
        "toomuchtoken": "Lỗi: Mã thông báo bắt buộc tối thiểu lớn hơn Kích thước ngữ cảnh tối đa.",
        "unknownModel": "Lỗi: Đã chọn mô hình không xác định",
        "httpError": "Lỗi: lỗi trong yêu cầu:",
        "noData": "Tệp này có vẻ không hợp lệ hoặc dữ liệu đã bị hỏng.",
        "onlyOneChat": "Phải có ít nhất một cuộc trò chuyện",
        "noUserIcon": "Bạn phải đặt biểu tượng của mình trước.",
        "emptyText": "Text is empty.",
        "wrongPassword": "Wrong Password",
        "networkFetch": "This happens when the network is unstable or the server is down.",
        "networkFetchWeb": "This can be a CORS error. this only happens when using web version dude to limitations of the browser. try using desktop local version, or other version of PocketRisu.",
        "networkFetchPlain": "This can be a plain fetch error. try disabling force plain fetch option in settings.",
        "requestLogRemoved": "This request log is removed.",
        "requestLogRemovedDesc": "This request log removes when client is refreshed or reloaded.",
        "vertexAuthError": "Thiếu thông tin xác thực Vertex AI.",
        "coldStorageWriteFailed": "Ghi vào bộ nhớ lạnh thất bại. Dữ liệu trò chuyện của bạn đã được bảo toàn.",
        "coldStorageVerifyFailed": "Xác minh bộ nhớ lạnh thất bại. Dữ liệu trò chuyện của bạn đã được bảo toàn."
    },
    "showHelp": "Hiển thị trợ giúp",
    help: helpVi,
    "setup": {
        "chooseProvider": "Chọn nhà cung cấp AI",
        "openaikey": "OpenAI với Khóa API (Được khuyến nghị)",
        "openaiProxy": "Proxy ngược OpenAI",
        "setupmodelself": "Người khác/Tôi sẽ tự thiết lập",
        "inputApiKey": "Nhập khóa API tại đây",
        "apiKeyhelp": "Bạn có thể lấy khóa api từ:",
        "setupSelfHelp": "Tự thiết lập trong cài đặt, sau khi màn hình Chào mừng kết thúc.",
        "theme": "Chọn chủ đề của bạn",
        "themeDescWifulike": "Không phù hợp với di động",
        "themeDescWifuCut": "Thích hợp cho di động",
        "themeDescClassic": "Thích hợp cho mọi thiết bị",
        "texttheme": "Chọn màu văn bản của bạn",
        "inputName": "Cuối cùng, nhập Biệt hiệu của bạn.",
        "welcome": "Chào mừng đến với PocketRisu! Tôi là Airisu, tôi ở đây để hướng dẫn bạn cài đặt PocketRisu. Trước tiên, tôi có thể gọi bạn là gì?",
        "welcome2": "Xin chào {username}! Trước khi bắt đầu, tôi sẽ hỏi bạn một số câu hỏi. Bạn có thể thay đổi các cài đặt này sau trong phần cài đặt.\n\nĐầu tiên hãy chọn nhà cung cấp AI.",
        "openRouterProvider": "OpenRouter có rất nhiều mô hình, một số không được lọc và một số miễn phí, nhưng nó không tốt bằng OpenAI.",
        "hordeProvider": "Horde là nhà cung cấp miễn phí, nhưng thời gian phản hồi lâu và chất lượng thấp.",
        "setProviderLater": "Có các nhà cung cấp khác, nhưng bạn có thể cài đặt sau trong phần cài đặt. Chọn mục này nếu bạn muốn cài đặt sau.",
        "setupOpenAI": "Để sử dụng OpenAI, bạn cần lấy khóa API. \n1. đi tới https://beta.openai.com/ \n2. đăng nhập bằng tài khoản của bạn \n3. đi tới https://beta.openai.com/account/api-keys \n4. nhấp vào 'Create New API Key' và đặt tên cho khóa của bạn bất cứ điều gì bạn muốn. \n5. sao chép khóa trên trang web.\n6. quay lại PocketRisu\n7. dán nó và nhấp vào nút gửi.",
        "setupClaude": "Để sử dụng Claude, bạn cần lấy khóa API.",
        "setupClaudeSteps": [
            "Truy cập URL này và Đăng nhập bằng Google",
            "Nhập thông tin của bạn và nhấp vào 'Continue'",
            "Trên trang tổ chức, chỉ cần nhập bất kỳ tên nào vào ô đầu tiên và nhấp vào 'Create Account'",
            "Nhấn nút 'Buy Credits'",
            "Nhấn nút 'Complete Setup'",
            "Nhập giống như hình trên, ngoại trừ phần quốc gia, bạn cần nhập quốc gia của mình. sau đó nhấn 'Continue'",
            "Thêm phương thức thanh toán của bạn và nhấn 'Continue'",
            "Sau khi thanh toán đã được đăng ký, nhấn 'Add Funds' và thêm tiền. bạn có thể thêm tối thiểu 5$ hoặc bạn có thể thiết lập tự động nạp tiền.",
            "Sau khi thêm tiền, hãy chuyển đến trang tổng quan và nhấn nút 'Get API Keys'",
            "Nhấn nút \"Create API Key\"",
            "Nhập giống như hình trên và nhấn 'Add'",
            "Sao chép khóa và dán vào đây và gửi đi."
        ],
        "setupOpenRouter": "Để sử dụng OpenRouter, bạn cần lấy khóa API. \n1. đi tới https://openrouter.ai/keys\n2. nhấp vào 'Create Key'\n3. đặt tên khóa bất cứ điều gì bạn muốn.\n4. sao chép khóa trên trang web\n5. quay lại PocketRisu\n6. dán nó và nhấp vào nút gửi.",
        "allDone": "Xong tất cả! vui lòng đợi một chút.",
        "setupLaterMessage": "Chào mừng {username}! bạn muốn tôi hướng dẫn cài đặt hay tự làm?",
        "setupMessageOption1": "Hướng dẫn tôi cài đặt",
        "setupMessageOption1Desc": "Khuyên dùng cho người dùng mới",
        "setupMessageOption2": "Tôi sẽ tự cài đặt",
        "claudeDesc": "Claude là mô hình AI được tạo bởi Anthropic, đối thủ cạnh tranh của OpenAI. Nó tốt hơn GPT nếu bạn muốn sử dụng bằng các ngôn ngữ khác ngoài tiếng Anh.",
        "openAIDesc": "OpenAI GPT là mô hình AI chất lượng cao, nhưng phải trả phí và được lọc, và yếu ở các ngôn ngữ khác ngoài tiếng Anh.",
        "chooseChatType": "Tuyệt vời! Bây giờ hãy chọn ngôn ngữ trò chuyện.",
        "chooseChatTypeOption1": "Hoàn toàn tiếng Anh",
        "chooseChatTypeOption1Desc": "Điều này sẽ khiến AI sử dụng tiếng Anh và nhập/xuất bằng tiếng Anh. Khuyên dùng cho người nói tiếng Anh.",
        "chooseChatTypeOption2": "Xử lý bằng tiếng Anh",
        "chooseChatTypeOption2Desc": "Điều này sẽ khiến AI sử dụng tiếng Anh nội bộ, nhưng đầu vào/đầu ra sẽ bằng ngôn ngữ của bạn. Được đề xuất cho người không nói tiếng Anh.",
        "chooseChatTypeOption3": "Không tập trung vào ngôn ngữ",
        "chooseChatTypeOption3Desc": "Điều này sẽ khiến AI sử dụng ngôn ngữ của bạn nội bộ, nhưng có thể làm giảm chất lượng.",
        "chooseCheapOrMemory": "Nhân tiện, bạn thích bộ nhớ hay giá rẻ hơn?",
        "chooseCheapOrMemoryOption1": "Bộ nhớ",
        "chooseCheapOrMemoryOption1Desc": "Điều này sẽ khiến AI ghi nhớ nhiều hơn, nhưng sẽ khá đắt.",
        "chooseCheapOrMemoryOption2": "Giá rẻ",
        "chooseCheapOrMemoryOption2Desc": "Điều này sẽ khiến AI ghi nhớ ít hơn, nhưng sẽ rẻ hơn.",
        "chooseCheapOrMemoryOption3": "Cân bằng",
        "chooseCheapOrMemoryOption3Desc": "Điều này sẽ khiến AI ghi nhớ nhiều hơn giá rẻ, nhưng ít hơn bộ nhớ.",
        "chooseCheapOrMemoryOption4": "Không giới hạn",
        "chooseCheapOrMemoryOption4Desc": "Điều này sẽ khiến AI ghi nhớ hầu hết mọi thứ, nhưng sẽ rất đắt.",
        "finally": "Cuối cùng, bạn có muốn bật các công cụ nâng cao không?",
        "finallyOption1": "Có",
        "finallyOption1Desc": "Điều này sẽ bật các công cụ nâng cao, nhưng sẽ làm cho giao diện người dùng phức tạp hơn. Khuyên dùng cho người dùng nâng cao.",
        "finallyOption2": "Không",
        "finallyOption2Desc": "Điều này sẽ tắt các công cụ nâng cao và làm cho giao diện người dùng đơn giản hơn. Khuyên dùng cho người dùng mới.",
        "igpPrompt": "Nếu IGP Prompt không trống, nó sẽ được thực thi sau yêu cầu mô hình chính, sau khi thực thi mô hình chính, dưới dạng mô hình cảm xúc, thêm kết quả sau phản hồi mô hình chính."
    },
    "triggerCategories": {
        "Special": "Đặc biệt",
        "Control": "Điều khiển",
        "Chat": "Trò chuyện",
        "Low Level": "Cấp thấp",
        "Alert": "Cảnh báo",
        "Lorebook V2": "Sách truyền thuyết V2",
        "String": "Chuỗi",
        "Data": "Dữ liệu",
        "Array": "Mảng",
        "Others": "Khác",
        "Deprecated": "Không dùng nữa"
    },
    "triggerDesc": {
        "v2Header": "Tiêu đề",
        "v2HeaderDesc": "Tiêu đề",
        "v2If": "Nếu",
        "v2IfDesc": "Nếu {{source}} {{condition}} {{target}}",
        "v2Else": "Ngược lại",
        "v2ElseDesc": "Ngược lại",
        "v2EndIndent": "Kết thúc thụt lề",
        "v2EndIndentDesc": "Kết thúc thụt lề",
        "v2SetVar": "Đặt biến",
        "v2SetVarDesc": "Đặt biến {{var}} {{operator}} {{value}}",
        "v2Loop": "Lặp lại mãi mãi",
        "v2LoopDesc": "Lặp lại mãi mãi",
        "v2BreakLoop": "Ngắt vòng lặp",
        "v2BreakLoopDesc": "Ngắt vòng lặp",
        "v2RunTrigger": "Chạy Trigger",
        "v2RunTriggerDesc": "Chạy Trigger {{target}}",
        "v2ConsoleLog": "Nhật ký Console",
        "v2ConsoleLogDesc": "Nhật ký Console {{source}}",
        "v2StopTrigger": "Dừng Trigger",
        "v2StopTriggerDesc": "Dừng Trigger",
        "v2CutChat": "Cắt trò chuyện",
        "v2CutChatDesc": "Cắt trò chuyện từ {{start}} đến {{end}}",
        "v2ModifyChat": "Sửa đổi trò chuyện",
        "v2ModifyChatDesc": "Sửa đổi trò chuyện tại chỉ số {{index}} với {{value}}",
        "v2SystemPrompt": "Thêm lời nhắc hệ thống",
        "v2SystemPromptDesc": "Thêm lời nhắc hệ thống tại {{location}} với {{value}}",
        "v2Impersonate": "Gửi trò chuyện",
        "v2ImpersonateDesc": "Gửi trò chuyện dưới dạng {{role}} với {{value}}",
        "v2Command": "Chạy lệnh",
        "v2CommandDesc": "Chạy lệnh với {{value}}",
        "v2SendAIprompt": "Gửi lời nhắc AI",
        "v2SendAIpromptDesc": "Gửi lời nhắc AI",
        "v2ImgGen": "Tạo hình ảnh",
        "v2ImgGenDesc": "Tạo hình ảnh từ {{value}}, phủ định từ {{negValue}} => {{outputVar}}",
        "v2CheckSimilarity": "Kiểm tra độ tương đồng",
        "v2CheckSimilarityDesc": "Kiểm tra độ tương đồng giữa {{source}} và {{value}} => {{outputVar}}",
        "v2RunLLM": "Chạy mô hình",
        "v2RunLLMDesc": "Gửi yêu cầu đến mô hình từ {{value}} => {{outputVar}}",
        "v2ShowAlert": "Hiển thị cảnh báo",
        "v2ShowAlertDesc": "Hiển thị cảnh báo với {{value}}",
        "v2ExtractRegex": "Trích xuất Regex",
        "v2ExtractRegexDesc": "Trích xuất văn bản từ {{value}} bằng regex {{regexType}} {{regex}} và cờ {{flagsType}} {{flags}}, sau đó lưu kết quả dưới dạng {{resultType}} {{result}} => {{outputVar}}",
        "v2RegexTest": "Kiểm tra Regex",
        "v2RegexTestDesc": "Kiểm tra {{value}} bằng regex {{regex}} và cờ {{flags}} => {{outputVar}}",
        "v2GetLastMessage": "Lấy tin nhắn cuối cùng",
        "v2GetLastMessageDesc": "Lấy tin nhắn cuối cùng => {{outputVar}}",
        "v2GetMessageAtIndex": "Lấy tin nhắn tại chỉ số",
        "v2GetMessageAtIndexDesc": "Lấy tin nhắn tại chỉ số {{index}} => {{outputVar}}",
        "v2GetMessageCount": "Lấy số lượng tin nhắn",
        "v2GetMessageCountDesc": "Lấy số lượng tin nhắn => {{outputVar}}",
        "v2GetLorebook": "Lấy Sách truyền thuyết",
        "v2GetLorebookDesc": "Lấy Sách truyền thuyết tên {{target}} => {{outputVar}}",
        "v2GetLorebookCount": "Lấy số lượng Sách truyền thuyết",
        "v2GetLorebookCountDesc": "Lấy số lượng Sách truyền thuyết => {{outputVar}}",
        "v2GetLorebookEntry": "Lấy Sách truyền thuyết với chỉ số",
        "v2GetLorebookEntryDesc": "Lấy Sách truyền thuyết với chỉ số {{index}} => {{outputVar}}",
        "v2SetLorebookActivation": "Đặt kích hoạt Sách truyền thuyết",
        "v2SetLorebookActivationDesc": "Đặt trạng thái kích hoạt của Sách truyền thuyết có chỉ số {{index}} thành {{value}}",
        "v2GetLorebookIndexViaName": "Lấy chỉ số Sách truyền thuyết qua Tên",
        "v2GetLorebookIndexViaNameDesc": "Lấy chỉ số Sách truyền thuyết qua Tên {{name}} => {{outputVar}}",
        "v2ModifyLorebook": "Sửa đổi Sách truyền thuyết",
        "v2ModifyLorebookDesc": "Sửa đổi Sách truyền thuyết tên {{target}} với {{value}}",
        "v2LoopNTimes": "Lặp lại N lần",
        "v2LoopNTimesDesc": "Lặp lại {{value}} lần",
        "v2Random": "Ngẫu nhiên",
        "v2RandomDesc": "Ngẫu nhiên từ {{min}} đến {{max}} => {{outputVar}}",
        "v2GetCharAt": "Lấy ký tự tại chỉ số",
        "v2GetCharAtDesc": "Lấy ký tự tại chỉ số {{index}} từ {{source}} => {{outputVar}}",
        "v2GetCharCount": "Lấy số lượng ký tự",
        "v2GetCharCountDesc": "Lấy số lượng ký tự từ {{source}} => {{outputVar}}",
        "v2ToLowerCase": "Chuyển thành chữ thường",
        "v2ToLowerCaseDesc": "Chuyển {{source}} thành chữ thường => {{outputVar}}",
        "v2ToUpperCase": "Chuyển thành chữ hoa",
        "v2ToUpperCaseDesc": "Chuyển {{source}} thành chữ hoa => {{outputVar}}",
        "v2SetCharAt": "Đặt ký tự tại chỉ số",
        "v2SetCharAtDesc": "Đặt ký tự tại chỉ số {{index}} trong {{source}} thành {{value}} => {{outputVar}}",
        "v2SplitString": "Tách chuỗi",
        "v2SplitStringDesc": "Tách {{source}} bằng {{delimiter}} => {{outputVar}}",
        "v2GetCharacterDesc": "Lấy mô tả nhân vật",
        "v2GetCharacterDescDesc": "Lấy mô tả nhân vật => {{outputVar}}",
        "v2SetCharacterDesc": "Đặt mô tả nhân vật",
        "v2SetCharacterDescDesc": "Đặt mô tả nhân vật thành {{value}}",
        "v2GetPersonaDesc": "Lấy lời nhắc Persona",
        "v2GetPersonaDescDesc": "Lấy lời nhắc Persona => {{outputVar}}",
        "v2SetPersonaDesc": "Đặt lời nhắc Persona",
        "v2SetPersonaDescDesc": "Đặt lời nhắc Persona thành {{value}}",
        "v2GetReplaceGlobalNote": "Lấy Ghi chú chung thay thế",
        "v2GetReplaceGlobalNoteDesc": "Lấy Ghi chú chung thay thế => {{outputVar}}",
        "v2SetReplaceGlobalNote": "Đặt Ghi chú chung thay thế",
        "v2SetReplaceGlobalNoteDesc": "Đặt Ghi chú chung thay thế thành {{value}}",
        "v2GetAuthorNote": "Lấy Ghi chú tác giả",
        "v2GetAuthorNoteDesc": "Lấy Ghi chú tác giả => {{outputVar}}",
        "v2SetAuthorNote": "Đặt Ghi chú tác giả",
        "v2SetAuthorNoteDesc": "Đặt Ghi chú tác giả thành {{value}}",
        "v2Comment": "Thêm bình luận",
        "v2CommentDesc": "{{value}}",
        "v2DeclareLocalVar": "Khai báo biến cục bộ",
        "v2DeclareLocalVarDesc": "Khai báo biến cục bộ {{var}} với giá trị {{value}}",
        "v2MakeArrayVar": "Tạo biến mảng",
        "v2MakeArrayVarDesc": "Tạo biến mảng {{var}}",
        "v2GetArrayVarLength": "Lấy độ dài biến mảng",
        "v2GetArrayVarLengthDesc": "Lấy độ dài của biến mảng {{var}} => {{outputVar}}",
        "v2GetArrayVar": "Lấy biến mảng",
        "v2GetArrayVarDesc": "Lấy giá trị tại chỉ số {{index}} từ biến mảng {{var}} => {{outputVar}}",
        "v2SetArrayVar": "Đặt biến mảng",
        "v2SetArrayVarDesc": "Đặt giá trị tại chỉ số {{index}} trong biến mảng {{var}} thành {{value}}",
        "v2PushArrayVar": "Thêm vào biến mảng",
        "v2PushArrayVarDesc": "Thêm {{value}} vào biến mảng {{var}}",
        "v2PopArrayVar": "Xóa giá trị cuối cùng từ biến mảng và lấy",
        "v2PopArrayVarDesc": "Xóa giá trị cuối cùng từ biến mảng {{var}} => {{outputVar}}",
        "v2ShiftArrayVar": "Xóa giá trị đầu tiên từ biến mảng và lấy",
        "v2ShiftArrayVarDesc": "Xóa giá trị đầu tiên từ biến mảng {{var}} => {{outputVar}}",
        "v2UnshiftArrayVar": "Thêm vào biến mảng làm giá trị đầu tiên",
        "v2UnshiftArrayVarDesc": "Thêm {{value}} làm giá trị đầu tiên của biến mảng {{var}}",
        "v2SpliceArrayVar": "Thêm vào biến mảng tại chỉ số",
        "v2SpliceArrayVarDesc": "Thêm {{value}} làm giá trị {{start}} của biến mảng {{var}}",
        "v2SliceArrayVar": "Cắt biến mảng",
        "v2SliceArrayVarDesc": "Cắt biến mảng {{var}} từ {{start}} đến {{end}} => {{outputVar}}",
        "v2GetIndexOfValueInArrayVar": "Lấy chỉ số của giá trị trong biến mảng",
        "v2GetIndexOfValueInArrayVarDesc": "Lấy chỉ số của {{value}} trong biến mảng {{var}} => {{outputVar}}",
        "v2RemoveIndexFromArrayVar": "Xóa chỉ số khỏi biến mảng",
        "v2RemoveIndexFromArrayVarDesc": "Xóa giá trị tại chỉ số {{index}} khỏi biến mảng {{var}}",
        "v2JoinArrayVar": "Nối mảng",
        "v2JoinArrayVarDesc": "Nối mảng {{var}} bằng {{delimiter}} => {{outputVar}}",
        "v2MakeDictVar": "Tạo biến từ điển",
        "v2MakeDictVarDesc": "Tạo biến từ điển {{var}}",
        "v2GetDictVar": "Lấy giá trị từ điển",
        "v2GetDictVarDesc": "Lấy giá trị cho khóa {{key}} từ từ điển {{var}} => {{outputVar}}",
        "v2SetDictVar": "Đặt giá trị từ điển",
        "v2SetDictVarDesc": "Đặt giá trị cho khóa {{key}} trong từ điển {{var}} thành {{value}}",
        "v2DeleteDictKey": "Xóa khóa từ điển",
        "v2DeleteDictKeyDesc": "Xóa khóa {{key}} khỏi từ điển {{var}}",
        "v2HasDictKey": "Có khóa từ điển",
        "v2HasDictKeyDesc": "Kiểm tra nếu từ điển {{var}} có khóa {{key}} => {{outputVar}}",
        "v2ClearDict": "Xóa từ điển",
        "v2ClearDictDesc": "Xóa từ điển {{var}}",
        "v2GetDictSize": "Lấy kích thước từ điển",
        "v2GetDictSizeDesc": "Lấy kích thước của từ điển {{var}} => {{outputVar}}",
        "v2GetDictKeys": "Lấy các khóa từ điển",
        "v2GetDictKeysDesc": "Lấy tất cả các khóa từ từ điển {{var}} => {{outputVar}}",
        "v2GetDictValues": "Lấy các giá trị từ điển",
        "v2GetDictValuesDesc": "Lấy tất cả các giá trị từ từ điển {{var}} => {{outputVar}}",
        "v2ConcatString": "Nối chuỗi",
        "v2ConcatStringDesc": "Nối {{source1}} và {{source2}} => {{outputVar}}",
        "v2GetLastUserMessage": "Lấy tin nhắn người dùng cuối cùng",
        "v2GetLastUserMessageDesc": "Lấy tin nhắn người dùng cuối cùng => {{outputVar}}",
        "v2GetLastCharMessage": "Lấy tin nhắn nhân vật cuối cùng",
        "v2GetLastCharMessageDesc": "Lấy tin nhắn nhân vật cuối cùng => {{outputVar}}",
        "v2GetFirstMessage": "Lấy tin nhắn đầu tiên",
        "v2GetFirstMessageDesc": "Lấy tin nhắn đầu tiên => {{outputVar}}",
        "v2GetAlertInput": "Lấy đầu vào cảnh báo",
        "v2GetAlertInputDesc": "Lấy đầu vào cảnh báo => {{outputVar}}",
        "v2GetAlertSelect": "Lấy lựa chọn cảnh báo",
        "v2GetAlertSelectDesc": "Lấy lựa chọn cảnh báo {{display}} tùy chọn {{value}} => {{outputVar}}",
        "v2UnsupportedTrigger": "Trigger không được hỗ trợ",
        "v2UnsupportedTriggerDesc": "Trigger không được hỗ trợ",
        "v2GetDisplayState": "Lấy trạng thái hiển thị",
        "v2GetDisplayStateDesc": "Lấy trạng thái hiển thị => {{outputVar}}",
        "v2SetDisplayState": "Đặt trạng thái hiển thị",
        "v2SetDisplayStateDesc": "Đặt trạng thái hiển thị thành {{value}}",
        "v2UpdateGUI": "Cập nhật GUI",
        "v2UpdateGUIDesc": "Cập nhật GUI",
        "v2UpdateChatAt": "Cập nhật trò chuyện tại chỉ số",
        "v2UpdateChatAtDesc": "Vẽ lại trò chuyện tại {{index}}",
        "v2Wait": "Chờ",
        "v2WaitDesc": "Chờ {{value}} giây",
        "v2GetRequestState": "Lấy nội dung dữ liệu yêu cầu",
        "v2GetRequestStateDesc": "Lấy nội dung yêu cầu tại {{index}} => {{outputVar}}",
        "v2SetRequestState": "Đặt nội dung dữ liệu yêu cầu",
        "v2SetRequestStateDesc": "Đặt nội dung yêu cầu tại {{index}} thành {{value}}",
        "v2GetRequestStateRole": "Lấy vai trò dữ liệu yêu cầu",
        "v2GetRequestStateRoleDesc": "Lấy vai trò dữ liệu yêu cầu tại {{index}} => {{outputVar}}",
        "v2SetRequestStateRole": "Đặt vai trò dữ liệu yêu cầu",
        "v2SetRequestStateRoleDesc": "Đặt vai trò dữ liệu yêu cầu tại {{index}} thành {{value}}",
        "v2GetRequestStateLength": "Lấy độ dài dữ liệu yêu cầu",
        "v2GetRequestStateLengthDesc": "Lấy độ dài dữ liệu yêu cầu => {{outputVar}}",
        "v2IfAdvanced": "Nếu",
        "v2IfAdvancedDesc": "Nếu {{source}} {{condition}} {{target}}",
        "v2QuickSearchChat": "Tìm kiếm nhanh trong trò chuyện",
        "v2QuickSearchChatDesc": "Tìm kiếm nhanh {{value}} trong trò chuyện với điều kiện {{condition}} ở độ sâu {{depth}} => {{outputVar}}",
        "v2StopPromptSending": "Dừng gửi lời nhắc",
        "v2StopPromptSendingDesc": "Dừng gửi lời nhắc",
        "v2Tokenize": "Tokenize",
        "v2TokenizeDesc": "Tokenize {{value}} => {{outputVar}}",
        "v2GetAllLorebooks": "Lấy tất cả Sách truyền thuyết",
        "v2GetAllLorebooksDesc": "Lấy tất cả lời nhắc Sách truyền thuyết dưới dạng mảng => {{outputVar}}",
        "v2GetLorebookByName": "Lấy chỉ số Sách truyền thuyết theo tên",
        "v2GetLorebookByNameDesc": "Lấy mảng chỉ số Sách truyền thuyết theo tên {{name}} => {{outputVar}}",
        "v2GetLorebookByIndex": "Lấy Sách truyền thuyết",
        "v2GetLorebookByIndexDesc": "Lấy lời nhắc Sách truyền thuyết tại chỉ số {{index}} => {{outputVar}}",
        "v2CreateLorebook": "Tạo Sách truyền thuyết",
        "v2CreateLorebookDesc": "Tạo Sách truyền thuyết với tên {{name}}, khóa {{key}}, nội dung {{content}}",
        "v2ModifyLorebookByIndex": "Sửa đổi Sách truyền thuyết",
        "v2ModifyLorebookByIndexDesc": "Sửa đổi Sách truyền thuyết tại chỉ số {{index}} với tên {{name}}, khóa {{key}}, nội dung {{content}}",
        "v2DeleteLorebookByIndex": "Xóa Sách truyền thuyết",
        "v2DeleteLorebookByIndexDesc": "Xóa Sách truyền thuyết tại chỉ số {{index}}",
        "v2GetLorebookCountNew": "Lấy số lượng Sách truyền thuyết",
        "v2GetLorebookCountNewDesc": "Lấy tổng số Sách truyền thuyết => {{outputVar}}",
        "v2SetLorebookAlwaysActive": "Đặt Sách truyền thuyết luôn hoạt động",
        "v2SetLorebookAlwaysActiveDesc": "Đặt Sách truyền thuyết tại chỉ số {{index}} luôn hoạt động thành {{value}}",
        "v2Calculate": "Tính toán",
        "v2CalculateDesc": "Tính toán {{expression}} => {{outputVar}}",
        "v2ReplaceString": "Thay thế chuỗi",
        "v2ReplaceStringDesc": "Thay thế {{source}} bằng regex {{regex}} thành {{replacement}} => {{outputVar}}"
    },
    "triggerInputLabels": {
        "value": "Giá trị",
        "var": "Biến",
        "varName": "Tên biến",
        "outputVar": "Biến đầu ra",
        "name": "Tên",
        "index": "Chỉ số",
        "source": "Nguồn",
        "target": "Đích",
        "condition": "Điều kiện",
        "operator": "Toán tử",
        "role": "Vai trò",
        "location": "Vị trí",
        "prompt": "Lời nhắc",
        "model": "Mô hình",
        "start": "Bắt đầu",
        "end": "Kết thúc",
        "min": "Tối thiểu",
        "max": "Tối đa",
        "delimiter": "Dấu phân cách",
        "depth": "Độ sâu",
        "key": "Khóa",
        "alertContent": "Nội dung cảnh báo",
        "options": "Tùy chọn",
        "cmd": "Lệnh",
        "regex": "Regex",
        "replacement": "Thay thế",
        "flags": "Cờ",
        "negPrompt": "Lời nhắc phủ định",
        "resultFormat": "Định dạng kết quả",
        "activationKeys": "Khóa kích hoạt",
        "insertOrder": "Thứ tự chèn",
        "sysStart": "Hệ thống bắt đầu",
        "sysHistoryEnd": "Hệ thống kết thúc lịch sử",
        "sysPromptEnd": "Hệ thống kết thúc lời nhắc",
        "addElse": "Thêm Else",
        "alwaysActive": "Luôn hoạt động",
        "trigger": "Trigger",
        "triggerOn": "Kích hoạt bật",
        "valueTypeDesc": "Sử dụng trực tiếp giá trị đầu vào",
        "varTypeDesc": "Sử dụng giá trị được lưu trong biến",
        "conditionEqual": "Bằng (=)",
        "conditionNotEqual": "Không bằng (≠)",
        "conditionGreater": "Lớn hơn (>)",
        "conditionLess": "Nhỏ hơn (<)",
        "conditionGreaterEqual": "Lớn hơn hoặc bằng (≥)",
        "conditionLessEqual": "Nhỏ hơn hoặc bằng (≤)",
        "conditionSimilar": "Tương tự (≒)",
        "conditionContains": "Chứa (∋)",
        "conditionIn": "Trong (∈)",
        "conditionNotContains": "Không chứa (∌)",
        "conditionNotIn": "Không trong (∉)",
        "conditionTruthy": "Đúng (≡)",
        "operatorSet": "Đặt (=)",
        "operatorAdd": "Cộng (+=)",
        "operatorSubtract": "Trừ (-=)",
        "operatorMultiply": "Nhân (*=)",
        "operatorDivide": "Chia (/=)",
        "operatorModulo": "Chia lấy dư (%=)",
        "searchLoose": "Tìm kiếm lỏng lẻo",
        "searchStrict": "Tìm kiếm nghiêm ngặt",
        "searchRegex": "Tìm kiếm Regex",
        "modelMain": "Mô hình chính",
        "modelSub": "Mô hình phụ",
        "roleUser": "Người dùng",
        "roleChar": "Nhân vật",
        "roleSystem": "Hệ thống",
        "roleAssistant": "Trợ lý",
        "boolTrue": "Đúng",
        "boolFalse": "Sai",
        "boolNull": "Null",
        "helpVarName": "Nhập tên biến",
        "helpOutputVar": "Nhập tên biến để lưu kết quả",
        "helpIndex": "Chỉ số mảng hoặc tin nhắn",
        "helpRegex": "Nhập mẫu regex",
        "helpFlags": "Cờ Regex",
        "helpDelimiter": "Dấu phân cách để tách chuỗi",
        "helpActivationKeys": "Từ khóa kích hoạt phân tách bằng dấu phẩy",
        "helpInsertOrder": "Thứ tự chèn",
        "helpDepth": "Độ sâu tin nhắn để tìm kiếm",
        "helpMinMax": "Phạm vi giá trị tối thiểu và tối đa",
        "helpSlot": "Sử dụng {{slot}} để giữ nguyên",
        "expression": "Biểu thức"
    },
    "playground": {
        "playground": "Playground",
        "inlayDeleteConfirm": "Bạn có chắc muốn xóa \"{name}\" không?",
        "inlayDeleteMultipleConfirm": "Bạn có chắc muốn xóa ${count} tài sản được chọn không?",
        "inlayDeleteSelected": "Xóa mục đã chọn",
        "inlayDeselectAll": "Bỏ chọn tất cả",
        "inlayEmpty": "Không có tài sản nội tuyến đã lưu",
        "inlayEmptyDesc": "Hình ảnh, âm thanh và video được đính kèm hoặc tạo trong trò chuyện sẽ xuất hiện ở đây",
        "inlayExplorer": "Trình khám phá Tài sản Inlay",
        "inlayImageGallery": "Thư viện Hình ảnh Inlay",
        "inlayImageGalleryEmptyDesc": "Hình ảnh được đính kèm hoặc tạo trong trò chuyện sẽ xuất hiện ở đây",
        "inlaySelectAll": "Chọn tất cả",
        "inlayTotalAssets": "Tổng cộng ${count} tài sản",
        "inlayDelete": "Delete",
        "inlayLoadingMore": "Loading...",
        "inlayCreatedAt": "Created:",
        "inlayUpdatedAt": "Updated:",
        "inlaySort": "Sort",
        "inlaySortUpdatedDesc": "Updated ↓",
        "inlaySortUpdatedAsc": "Updated ↑",
        "inlaySortCreatedDesc": "Created ↓",
        "inlaySortCreatedAsc": "Created ↑",
        "inlayFilter": "Filter",
        "inlayFilterAll": "All",
        "inlayFilterMetaMissing": "Meta Missing",
        "inlayFilterOrphanCharacter": "Orphan Character",
        "inlayFilterOrphanChat": "Orphan Chat",
        "inlayOriginalLoadNeeded": "Original Load Needed",
        "inlayAudioAsset": "Audio Asset",
        "inlayVideoAsset": "Video Asset",
        "inlaySignatureAsset": "Signature Asset",
        "inlayInfo": "Info",
        "inlayManualMapping": "Manual Mapping",
        "inlayActions": "Actions",
        "inlayLoadingOriginal": "Loading original image...",
        "inlaySave": "Save",
        "inlaySaved": "Saved!",
    },
    "confirm": "Xác nhận",
    "yes": "Có",
    "no": "Không",
    "goback": "Quay lại",
    "botSettings": "Cài đặt bot",
    "model": "Người mẫu",
    "apiKey": "Mã API",
    "providerURL": "URL yêu cầu",
    "providerJSON": "JSON nội dung yêu cầu",
    "mainPrompt": "Lời nhắc chính",
    "jailbreakPrompt": "Lời nhắc Bẻ khóa",
    "globalNote": "Ghi chú chung",
    "autoSuggest": "Tự động đề xuất",
    "tokens": "Mã thông báo",
    "maxContextSize": "Kích thước ngữ cảnh tối đa",
    "maxResponseSize": "Kích thước phản hồi tối đa",
    "temperature": "Nhiệt độ",
    "frequencyPenalty": "Hình phạt tần số",
    "presensePenalty": "Hình phạt có mặt",
    "advancedSettings": "Cài đặt nâng cao",
    "advancedSettingsWarn": "Cảnh báo: Nếu bạn không biết tùy chọn này làm gì, đừng thay đổi nó!",
    "formatingOrder": "Thứ tự hình thành",
    "authorNote": "Ghi chú của tác giả",
    "firstMessage": "tin nhắn đầu tiên",
    "description": "Sự miêu tả",
    "note": "Ghi chú",
    "jailbreakToggle": "Chuyển đổi Bẻ khóa",
    "charIcon": "Biểu tượng nhân vật",
    "characterDisplay": "Hiển thị ký tự",
    "viewScreen": "Màn hình nhân vật bổ sung",
    "none": "Không có",
    "emotionImage": "Hình ảnh cảm xúc",
    "noImages": "Không có hình ảnh",
    "noBias": "Không thiên vị",
    "image": "Hình ảnh",
    "name": "Tên",
    "folderName": "Tên thư mục",
    "folderRemoveConfirm": "Thư mục này chứa sách truyền thuyết. Bạn có chắc chắn muốn xóa nó và tất cả nội dung của nó không?",
    "emotion": "Tên cảm xúc",
    "value": "Giá trị",
    "reroll": "tái sinh",
    "deleteRerollMessage": "Xóa tin nhắn tái sinh",
    "deleteRerollMessageConfirm": "Xóa tin nhắn tái sinh đang chọn?",
    "rerollConfirm": "Tạo tin nhắn mới và thêm vào danh sách?",
    "noSwipesRerollConfirm": "Hiện không có tin nhắn tái sinh bổ sung. Tạo tin nhắn mới và thêm vào danh sách?",
    "chatList": "Danh sách trò chuyện",
    "removeChat": "Xóa tin nhắn này?",
    "loreBook": "Sách truyền thuyết",
    "character": "Tính cách",
    "Chat": "Trò chuyện",
    "globalLoreInfo": "Lorebook nhân vật áp dụng cho tất cả các cuộc trò chuyện trong nhân vật.",
    "group": "Nhóm",
    "localLoreInfo": "Chat Lorebook chỉ áp dụng cho cuộc trò chuyện hiện tại.",
    "removeConfirm": "Bạn có thực sự muốn xóa:",
    "removeConfirm2": "Bạn có THỰC SỰ muốn loại bỏ:",
    "exportConfirm": "Bạn có muốn xuất cái này không?",
    "insertOrder": "Thứ tự chèn",
    "activationKeys": "Phím kích hoạt",
    "activationKeysInfo": "Được phân tách bằng dấu phẩy",
    "prompt": "Lời nhắc",
    "loreBookDepth": "Độ sâu tìm kiếm Lorebook",
    "loreBookToken": "Token tối đa của Lorebook",
    "removeCharacter": "Xóa ký tự",
    "exportCharacter": "Xuất ký tự",
    "userSetting": "Thiết lập người dùng",
    "username": "Tên của bạn",
    "userIcon": "Biểu tượng của bạn",
    "successExport": "Đã xuất thành công và tải xuống thư mục tải xuống của bạn",
    "successImport": "Đã nhập thành công",
    "moduleCreated": "Đã tạo mô-đun.",
    "moduleUpdated": "Đã cập nhật mô-đun.",
    "moduleDeleted": "Đã xóa mô-đun.",
    "importedCharacter": "Ký tự đã nhập",
    "alwaysActive": "Luôn luôn hoạt động",
    "additionalPrompt": "Lời nhắc bổ sung",
    "descriptionPrefix": "Tiền tố mô tả",
    "forceReplaceUrl": "Proxy ngược",
    "emotionWarn": "Mô hình phụ trợ được sử dụng.",
    "plugin": "Cắm vào",
    "language": "Ngôn ngữ",
    "UiLanguage": "Ngôn ngữ giao diện người dùng",
    "createfromScratch": "Tạo từ đầu",
    "importCharacter": "Nhập ký tự",
    "translator": "Người phiên dịch",
    "disabled": "Tàn tật",
    "noPluginSelected": "Mô hình được chọn làm plugin nhưng không có plugin nào được chọn.",
    "text": "Chữ",
    "UISize": "Kích thước văn bản trò chuyện",
    "newVersion": "Đã tìm thấy bản cập nhật, bạn có muốn cài đặt không?",
    "remindLaterQuestion": "Khi nào tôi nên nhắc bạn?",
    "remindIgnore": "Bỏ qua",
    "remindLater1Day": "Nhắc sau 1 ngày",
    "remindLater3Days": "Nhắc sau 3 ngày",
    "remindLater5Days": "Nhắc sau 5 ngày",
    "remindLater1Week": "Nhắc sau 1 tuần",
    "display": "Màn hình & Âm thanh",
    "useCustomBackground": "Tùy chỉnh nền",
    "translateInput": "Dịch đầu vào",
    "autoTranslation": "Dịch tự động",
    "fullscreen": "Toàn màn hình",
    "playMessage": "Phát âm thanh tin nhắn",
    "iconSize": "Kích cỡ biểu tượng",
    "single": "Đơn",
    "multiple": "Nhiều",
    "useCharLorebook": "Sử dụng truyền thuyết trong nhân vật",
    "selectChar": "Chọn nhân vật",
    "askLoadFirstMsg": "Chúng ta tải tin nhắn đầu tiên nhé?",
    "theme": "chủ đề",
    "editOrder": "Chỉnh sửa đơn hàng",
    "submodel": "Mô hình phụ trợ",
    "timeOutinSec": "Thời gian chờ (tính bằng giây)",
    "emotionPrompt": "Nhắc nhở cảm xúc",
    "singleView": "Chế độ xem đơn",
    "SpacedView": "Xem nhiều ký tự",
    "emphasizedView": "Chế độ xem nhân vật đôi",
    "pluginWarn": "Các plugin có thể gây ra sự cố khi cài đặt các plugin độc hại.",
    "pluginConfirm": "Bạn có thực sự muốn nhập plugin này không? Chỉ nhập plugin từ các nguồn đáng tin cậy.",
    "pluginContainsExternalMedia": "Plugin này chứa phương tiện bên ngoài.",
    "pluginContainsExternalJS": "Plugin này chứa Javascript bên ngoài.",
    "waifuWidth": "Chiều rộng trò chuyện Waifu",
    "files": "Các tập tin",
    "backupConfirm": "Bạn có thực sự muốn lưu bản sao lưu?",
    "backupLoadConfirm": "Bạn có thực sự muốn tải bản sao lưu? Tất cả dữ liệu sẽ bị mất!",
    "backupLoadConfirm2": "Bạn có thực sự muốn tải bản sao lưu không? Tất cả dữ liệu sẽ bị mất!",
    "others": "Người khác",
    "presets": "cài đặt trước",
    "imageGeneration": "Tạo hình ảnh",
    "provider": "Các nhà cung cấp",
    "key": "Chìa khóa",
    "noData": "Không có dữ liệu",
    "currentImageGeneration": "Dữ liệu tạo hình ảnh hiện tại",
    "promptPreprocess": "Sử dụng tiền xử lý nhanh chóng",
    "SwipeRegenerate": "Sử dụng Vuốt để tái tạo",
    "removeMessageOnly": "Chỉ xóa tin nhắn này",
    "removeMessageAndAfter": "Xóa tin nhắn này và các tin nhắn sau ({})",
    "messageRemoved": "Đã xóa tin nhắn",
    "messagesRemoved": "Đã xóa {} tin nhắn",
    "confirmReroll": "Xác nhận khi tái tạo tin nhắn",
    "textColor": "Văn bản màu",
    "classicRisu": "Risu cổ điển",
    "highcontrast": "Độ tương phản cao",
    "requestretrys": "Yêu cầu thử lại khi thất bại",
    "utilityBot": "Bot tiện ích",
    "ShowLog": "Hiển thị nhật ký yêu cầu",
    "waifuWidth2": "Kích thước ký tự Waifu",
    "sayNothing": "Nhập 'không nói gì' khi không nhập chuỗi",
    "regexScript": "Tập lệnh Regex",
    "type": "Kiểu",
    "editInput": "Sửa đổi đầu vào",
    "editOutput": "Sửa đổi đầu ra",
    "editProcess": "Sửa đổi dữ liệu yêu cầu",
    "loadLatest": "Tải bản sao lưu mới nhất",
    "loadOthers": "Tải các bản sao lưu khác",
    "exampleMessage": "Tin nhắn mẫu",
    "creatorNotes": "Bình luận của người sáng tạo",
    "systemPrompt": "Lời nhắc hệ thống",
    "characterNotes": "Ghi chú nhân vật",
    "personality": "Nhân cách",
    "scenario": "Kịch bản",
    "alternateGreetings": "Lời chào thay thế",
    "unrecommended": "Không được khuyến khích",
    "chatNotes": "Ghi chú trò chuyện",
    "showUnrecommended": "Hiển thị cài đặt không được đề xuất",
    "altGreet": "Tin nhắn đầu tiên thay thế",
    "scripts": "Tập lệnh",
    "settings": "Cài đặt",
    "selective": "chọn lọc",
    "SecondaryKeys": "Phím phụ",
    "useGlobalSettings": "Sử dụng Cài đặt chung",
    "recursiveScanning": "Quét đệ quy",
    "creator": "Người sáng tạo",
    "CharVersion": "Phiên bản nhân vật",
    "Speech": "Lời nói",
    "useExperimental": "Có thể thực hiện các tính năng thử nghiệm",
    "showMemoryLimit": "Hiển thị giới hạn bộ nhớ",
    "showFirstMessagePages": "Hiển thị trang tin nhắn đầu tiên",
    "roundIcons": "Biểu tượng tròn",
    "streaming": "Truyền phát",
    "chatBot": "Bot trò chuyện",
    "otherBots": "Bot khác",
    "user": "Người dùng",
    "additionalAssets": "Tài sản bổ sung",
    "editDisplay": "Sửa đổi hiển thị",
    "textBackgrounds": "Màu màn hình văn bản tùy chỉnh",
    "textBorder": "Đề cương văn bản",
    "textScreenRound": "Màn hình văn bản tròn",
    "textScreenBorder": "Viền màn hình văn bản",
    "ttsReadOnlyQuoted": "Chỉ đọc trích dẫn",
    "ttsStop": "Dừng TTS",
    "replaceGlobalNote": "Thay thế ghi chú toàn cầu",
    "charLoreBook": "Truyện nhân vật",
    "globalLoreBook": "Sách truyền thuyết toàn cầu",
    "globalRegexScript": "Regex toàn cầu",
    "accessibility": "Khả năng tiếp cận",
    "sendWithEnter": "Gửi bằng phím Enter(Shift + Enter chuyển sang gửi tin nhắn khi không kiểm tra.)",
    "fixedChatTextarea": "Cố định ở dưới khung chat",
    "clickToEdit": "Bấm vào văn bản để chỉnh sửa",
    "setNodePassword": "Đặt mật khẩu của bạn để bảo mật",
    "inputNodePassword": "Nhập mật khẩu của bạn. nếu bạn không nhớ, hãy xóa save/__password.txt trong tệp máy chủ của bạn và khởi động lại máy chủ.",
    "simple": "Đơn giản",
    "advanced": "Trình độ cao",
    "askReRollAutoSuggestions": "Đề xuất tự động cuộn lại",
    "creatingSuggestions": "Đang tạo đề xuất...",
    "active": "Tích cực",
    "loreRandomActivation": "Sử dụng điều kiện xác suất",
    "activationProbability": "Xác suất",
    "hub": "RisuRealm",
    "tags": "Thẻ",
    "backgroundHTML": "Nhúng nền",
    "copied": "Đã sao chép",
    "useChatCopy": "Sử dụng Sao chép tin nhắn trò chuyện",
    "useChatSticker": "Sử dụng nhãn dán trò chuyện",
    "useAdditionalAssetsPreview": "Sử dụng bản xem trước nội dung bổ sung",
    "autoTranslateInput": "Đầu vào dịch tự động",
    "enterMessageForTranslateToEnglish": "Nhập tin nhắn để dịch sang tiếng Anh",
    "recent": "Gần đây",
    "downloads": "Tải xuống",
    "trending": "Đang thịnh hành",
    "imageCompression": "Nén hình ảnh",
    "notLoggedIn": "Chưa đăng nhập vào tài khoản Risu",
    "SaveDataInAccount": "Lưu dữ liệu trong tài khoản",
    "dataSavingInAccount": "Lưu dữ liệu trong tài khoản",
    "logout": "Đăng xuất",
    "loadDataFromAccount": "Tải dữ liệu từ tài khoản",
    "saveCurrentDataToAccount": "Lưu dữ liệu hiện tại vào tài khoản",
    "chatAssumed": "--",
    "proxyAPIKey": "Khóa/Mật khẩu",
    "proxyRequestModel": "Mô hình yêu cầu proxy",
    "officialWiki": "Wiki chính thức",
    "officialWikiDesc": "Wiki chính thức của PocketRisu. cứ thoải mái xem nhé.",
    "officialDiscord": "Bất hòa chính thức",
    "officialDiscordDesc": "Discord chính thức nói về PocketRisu",
    "persona": "nhân cách",
    "icon": "Biểu tượng",
    "account": "Tài khoản",
    "remove": "Di dời",
    "able": "Có thể",
    "assetWidth": "Chiều rộng tối đa của hình ảnh nội dung",
    "animationSpeed": "Tốc độ hoạt ảnh",
    "screenshot": "Ảnh chụp màn hình",
    "screenshotSaved": "Đã lưu ảnh chụp màn hình",
    "createBotwithAI": "Tạo Bot từ AI",
    "changeFolderName": "Nhập tên thư mục mới (để trống để hủy)",
    "cancel": "Hủy bỏ",
    "renameFolder": "Đổi tên thư mục",
    "changeFolderColor": "Thay đổi màu thư mục",
    "changeFolderImage": "Thay đổi hình ảnh thư mục",
    "fullWordMatching": "So khớp từ đầy đủ",
    "botSettingAtStart": "Menu Bot khi khởi chạy",
    "triggerStart": "Đang trò chuyện Gửi",
    "triggerInput": "Trên đầu ra của người dùng",
    "triggerOutput": "Trên đầu ra của nhân vật",
    "triggerManual": "Chỉ kích hoạt thủ công",
    "triggerCondVar": "Nếu có thể thay đổi",
    "triggerCondExists": "Nếu văn bản tồn tại trên trò chuyện",
    "triggerScript": "Tập lệnh kích hoạt",
    "triggerMatchRegex": "Phù hợp với Regex",
    "triggerMatchLoose": "Trận đấu lỏng lẻo",
    "triggerMatchStrict": "Trận đấu nghiêm ngặt",
    "searchDepth": "Độ sâu tìm kiếm",
    "equal": "Tương đương với",
    "notEqual": "Không bằng",
    "greater": "Lớn hơn",
    "less": "Ít hơn",
    "greaterEqual": "Lớn hơn hoặc bằng",
    "lessEqual": "Nhỏ hơn hoặc bằng",
    "triggerEffSysPrompt": "Thêm lời nhắc hệ thống",
    "triggerEffSetVar": "Sửa đổi biến",
    "triggerEffImperson": "Gửi trò chuyện",
    "triggerEffCommand": "Chạy lệnh",
    "triggerEffRunTrigger": "Chạy Trigger",
    "triggerEffStop": "Dừng gửi lời nhắc",
    "triggerEffCall": "Gọi Trigger",
    "varableName": "Tên biến",
    "role": "Vai trò",
    "location": "Vị trí",
    "promptstart": "Bắt đầu lời nhắc",
    "promptend": "Kết thúc lời nhắc",
    "historyend": "Kết thúc lịch sử",
    "always": "Luôn luôn",
    "noEffect": "không có hiệu lực",
    "invaildTriggerEffect": "Hiệu ứng này không hoạt động đối với loại kích hoạt này.",
    "operator": "Nhà điều hành",
    "TriggerSetToVar": "Đặt thành Biến",
    "TriggerAddToVar": "Thêm vào biến",
    "TriggerSubToVar": "Trừ từ biến",
    "TriggerMulToVar": "Nhân với biến",
    "TriggerDivToVar": "Chia từ biến",
    "isNull": "chưa được thiết lập",
    "ifChatIndex": "Nếu chỉ mục trò chuyện",
    "ifRandom": "Nếu ngẫu nhiên",
    "ifValue": "Nếu giá trị",
    "hideRealm": "Khởi động RisuRealm thu gọn",
    "hideAllImages": "Ẩn tất cả hình ảnh",
    "hideMessagePageCount": "Ẩn bộ đếm trang tin nhắn",
    "popularityLevel": "{} Mức độ phổ biến",
    "colorScheme": "Bảng màu",
    "rangeStart": "Phạm vi bắt đầu",
    "rangeEnd": "Cuối phạm vi",
    "untilChatEnd": "Cho đến khi kết thúc cuộc trò chuyện",
    "usePromptTemplate": "Sử dụng mẫu nhắc nhở",
    "specialType": "Loại đặc biệt",
    "noSpecialType": "Không có loại đặc biệt",
    "forceProxyAsOpenAI": "Buộc định dạng proxy là OpenAI",
    "promptTemplate": "Mẫu nhắc nhở",
    "customInnerFormat": "Định dạng bên trong tùy chỉnh",
    "innerFormat": "Định dạng bên trong",
    "HypaMemory": "HypaBộ nhớ",
    "ToggleHypaMemory": "Chuyển đổi HypaMemory",
    "resetPromptTemplateConfirm": "Bạn có thực sự muốn đặt lại mẫu lời nhắc không?",
    "emotionMethod": "Phương pháp cảm xúc",
    "continueResponse": "Tiếp tục phản hồi",
    "showMenuChatList": "Hiển thị Menu Danh sách Trò chuyện",
    "translatorLanguage": "Ngôn ngữ dịch",
    "translatorType": "Loại dịch giả",
    "htmlTranslation": "Dịch HTML",
    "deeplKey": "Khóa API deepL",
    "deeplFreeKey": "Khóa API miễn phí deepL",
    "deeplXUrl": "deepLX URL",
    "deeplXToken": "deepLX Token",
    "exportPersona": "Xuất khẩu nhân vật",
    "importPersona": "Nhập khẩu nhân vật",
    "export": "Xuất khẩu",
    "import": "Nhập khẩu",
    "useNamePrefix": "Sử dụng tiền tố tên",
    "textAdventureNAI": "Chạy dưới dạng cuộc phiêu lưu văn bản",
    "appendNameNAI": "Nối tên vào NAI",
    "customStopWords": "Từ dừng tùy chỉnh",
    "defaultPrompt": "Lời nhắc mặc định",
    "additionalText": "Mô tả bổ sung",
    "seed": "Hạt giống (Seed)",
    "charjs": "CharacterJS",
    "depthPrompt": "Lời nhắc độ sâu",
    "largePortrait": "Chân dung",
    "reverseProxyOobaMode": "Chế độ Ooba",
    "exactTokens": "Token chính xác",
    "fixedTokens": "Token ước tính",
    "inlayViewScreen": "Màn hình Inlay",
    "imgGenPrompt": "Lời nhắc tạo hình ảnh",
    "imgGenNegatives": "Lời nhắc phủ định tạo hình ảnh",
    "imgGenInstructions": "Hướng dẫn tạo hình ảnh",
    "usePlainFetchWarn": "Vui lòng tắt tùy chọn này khi sử dụng NovelAI, vì nó có thể gây ra lỗi CORS khi sử dụng NovelAI.",
    "translationPrompt": "Lời nhắc dịch",
    "translationResponseSize": "Kích thước phản hồi dịch",
    "webdeeplwarn": "Tùy chọn này không được khuyến nghị sử dụng với phiên bản web, vì nó có thể gây ra lỗi CORS.",
    "saveBackupLocal": "Lưu sao lưu cục bộ",
    "loadBackupLocal": "Tải sao lưu cục bộ",
    "topP": "Top P",
    "genTimes": "Lựa chọn tạo",
    "cot": "Chuỗi suy nghĩ",
    "forcePlainFetch": "Buộc Plain Fetch",
    "autoFillRequestURL": "Tự động điền URL yêu cầu",
    "newOAIHandle": "Xử lý OpenAI mới",
    "inlayImage": "Tính năng hình ảnh Inlay",
    "nativeAutomark": "Native Automark thử nghiệm",
    "assistantPrefill": "Trợ lý điền trước",
    "postEndInnerFormat": "Đăng kết thúc",
    "sendChatAsSystem": "Gửi trò chuyện dưới dạng hệ thống",
    "sendName": "Gửi tên trong trò chuyện không phải nhóm",
    "utilOverride": "Ghi đè tiện ích",
    "template": "Mẫu",
    "chatAsOriginalOnSystem": "Gửi dưới dạng vai trò gốc",
    "exportAsDataset": "Xuất Lưu dưới dạng Dataset",
    "editTranslationDisplay": "Chỉnh sửa hiển thị dịch",
    "selectModel": "Chọn mô hình",
    "autoRemoveThoughtTag": "Xóa thẻ suy nghĩ",
    "customChainOfThought": "Chuỗi suy nghĩ tùy chỉnh",
    "maxThoughtTagDepth": "Độ sâu thẻ suy nghĩ tối đa",
    "openRouterFallback": "Sử dụng dự phòng",
    "openRouterMiddleOut": "Sử dụng Middle Out",
    "openRouterProviderOrder": "Thứ tự ưu tiên nhà cung cấp",
    "openRouterProviderOnly": "Nhà cung cấp được phép",
    "openRouterProviderIgnore": "Nhà cung cấp bị bỏ qua",
    "openRouterSearchModel": "Tìm kiếm mô hình...",
    "openRouterSortByName": "Tên",
    "openRouterSortByPrice": "Giá",
    "openRouterSortByProvider": "Nhà cung cấp",
    "openRouterSortAsc": "Tăng dần",
    "openRouterSortDesc": "Giảm dần",
    "geminiApiKey": "Khóa API Gemini",
    "memoryLimitThickness": "Độ dày giới hạn bộ nhớ",
    "inputCardPassword": "Nhập mật khẩu thẻ",
    "ccv2Desc": "Character Card V2 là định dạng được sử dụng rộng rãi trong các chương trình chatbot.",
    "ccv3Desc": "Character Card V3 là định dạng thế hệ tiếp theo được sử dụng trong các chương trình chatbot.",
    "rccDesc": "Risu Refined Character Card là định dạng có các tính năng bổ sung như mật khẩu, kiểm tra tính toàn vẹn, v.v.",
    "password": "Mật khẩu",
    "license": "Giấy phép",
    "licenseDesc": "Bạn có thể chọn giấy phép cho người tải xuống để giới hạn việc sử dụng lời nhắc của thẻ.",
    "passwordDesc": "Bạn có thể đặt mật khẩu để bảo vệ thẻ của mình khỏi truy cập trái phép.",
    "largePersonaPortrait": "Chân dung Persona",
    "module": "Mô-đun",
    "modules": "Mô-đun",
    "noModules": "Không có mô-đun nào được cài đặt.",
    "createModule": "Tạo mô-đun",
    "basicInfo": "Thông tin cơ bản",
    "moduleContent": "Nội dung mô-đun",
    "confirmRemoveModuleFeature": "Bạn có thực sự muốn xóa tính năng này không? Hành động này không thể hoàn tác.",
    "editModule": "Chỉnh sửa mô-đun",
    "importModule": "Nhập mô-đun",
    "download": "Tải xuống",
    "edit": "Chỉnh sửa",
    "enableGlobal": "Bật toàn cầu",
    "chatModulesInfo": "Bạn có thể bật hoặc tắt mô-đun cho cuộc trò chuyện này. Bạn cũng có thể bật cho nhân vật này bằng cách nhấp chuột phải hoặc nhấn và giữ nút bật.",
    "sideMenuRerollButton": "Nút Reroll menu bên",
    "persistentStorage": "Lưu trữ liên tục",
    "persistentStorageSuccess": "Lưu trữ đã được duy trì thành công",
    "persistentStorageFail": "Lưu trữ không được duy trì. Bạn đã từ chối yêu cầu?, hoặc trình duyệt không được hỗ trợ?",
    "persistentStorageRecommended": "Khuyên dùng Lưu trữ liên tục",
    "persistentStorageDesc": "Trình duyệt của bạn hỗ trợ lưu trữ liên tục. Điều này được khuyến nghị để có hiệu suất và trải nghiệm người dùng tốt hơn.",
    "enable": "Bật",
    "postFile": "Đăng tập tin",
    "requestInfoInsideChat": "Hiển thị thông tin yêu cầu trong trò chuyện",
    "inputTokens": "Token đầu vào",
    "outputTokens": "Token đầu ra",
    "tokenWarning": "Tính toán token có thể không chính xác. Nên sử dụng nó để tham khảo.",
    "log": "Nhật ký",
    "popularityLevelDesc": "Mức độ phổ biến tăng theo số lượt tải xuống, v.v. để ước tính, mức độ phổ biến 3.7 là khoảng 1 lượt tải xuống.",
    "additionalParams": "Tham số bổ sung",
    "heightMode": "Chế độ chiều cao",
    "useAdvancedEditor": "Sử dụng trình biên tập nâng cao",
    "noWaitForTranslate": "Không chờ dịch",
    "antiClaudeOverload": "Chống quá tải Claude",
    "activeTabChange": "Tab hiện tại bị vô hiệu hóa vì tab khác đang hoạt động. Để kích hoạt tab này, nhấp OK",
    "addCharacter": "Thêm nhân vật",
    "importFromRealm": "Chọn từ RisuRealm",
    "importFromRealmDesc": "Chọn hơn 1000 nhân vật trong RisuRealm",
    "random": "Ngẫu nhiên",
    "metaData": "Siêu dữ liệu",
    "autoContinueMinTokens": "Token mục tiêu (Tự động tiếp tục)",
    "autoContinueChat": "Chống phản hồi không hoàn chỉnh (Tự động tiếp tục)",
    "removeIncompleteResponse": "Xóa câu không hoàn chỉnh",
    "tokenizer": "Tokenizer",
    "chatFormating": "Định dạng trò chuyện",
    "useInstructPrompt": "Sử dụng lời nhắc hướng dẫn",
    "textAreaSize": "Kích thước vùng nhập",
    "textAreaTextSize": "Kích thước văn bản vùng nhập",
    "sideBarSize": "Kích thước thanh bên",
    "embedding": "Embedding",
    "syntax": "Cú pháp",
    "run": "Chạy",
    "noMessage": "Gõ gì đó để bắt đầu trò chuyện.",
    "combineTranslation": "Kết hợp dịch",
    "dynamicAssets": "Tài sản động",
    "dynamicAssetsEditDisplay": "Sử dụng tài sản động trong hiển thị",
    "longTermMemory": "Bộ nhớ dài hạn",
    "grid": "Lưới",
    "list": "Danh sách",
    "trash": "Thùng rác",
    "trashDesc": "Các nhân vật đã xóa sẽ được chuyển vào thùng rác. Bạn có thể khôi phục hoặc xóa vĩnh viễn chúng. Các nhân vật đã xóa sẽ tự động bị xóa sau 3 ngày.",
    "shareExport": "Chia sẻ/Xuất",
    "risupresetDesc": "Định dạng Risupreset là định dạng được thiết kế dành riêng cho các cài đặt trước PocketRisu.",
    "risuMDesc": "Định dạng RisuM là định dạng được thiết kế dành riêng cho các mô-đun PocketRisu.",
    "jsonDesc": "Định dạng JSON là định dạng dễ đọc và viết cho cả con người và máy móc.",
    "nickname": "Biệt danh",
    "useRegexLorebook": "Sử dụng Regex",
    "customPromptTemplateToggle": "Chuyển đổi tùy chỉnh",
    "defaultVariables": "Biến mặc định",
    "lowLevelAccess": "Truy cập cấp thấp",
    "resultStoredVar": "Biến lưu trữ kết quả",
    "triggerEffRunLLM": "Chạy mô hình chính",
    "triggerEffectSendAI": "Gửi lại AI",
    "triggerEffCheckSim": "Kiểm tra độ tương đồng",
    "triggerEffShowAlert": "Hiển thị cảnh báo",
    "normal": "Bình thường",
    "error": "Lỗi",
    "input": "Đầu vào",
    "select": "Chọn",
    "options": "Tùy chọn",
    "alertContent": "Nội dung cảnh báo",
    "lowLevelAccessConfirm": "Nội dung này sử dụng Truy cập cấp thấp. Điều đó có nghĩa là nội dung này có thể truy cập trực tiếp vào mô hình AI và bộ nhớ của bạn. Bạn có thực sự muốn nhập nội dung này không?",
    "triggerLowLevelOnly": "Trigger này chỉ hoạt động với Truy cập cấp thấp. Để bật trigger này, hãy bật Truy cập cấp thấp trong cài đặt nâng cao của nhân vật hoặc mô-đun.",
    "truthy": "Đúng (Truthy)",
    "extractRegex": "Trích xuất văn bản bằng Regex",
    "runImgGen": "Chạy tạo hình ảnh",
    "cutChat": "Cắt trò chuyện",
    "modifyChat": "Sửa đổi trò chuyện",
    "regex": "Regex",
    "flags": "Cờ",
    "resultFormat": "Định dạng kết quả",
    "negPrompt": "Lời nhắc phủ định",
    "start": "Bắt đầu",
    "end": "Kết thúc",
    "index": "Chỉ số",
    "search": "Tìm kiếm",
    "goCharacterOnImport": "Đi tới nhân vật khi nhập Realm",
    "format": "Định dạng",
    "v2Warning": "Cảnh báo: Thẻ V2 không còn được hỗ trợ. Nó có thể không chứa tất cả dữ liệu.",
    "applyModule": "Áp dụng mô-đun",
    "successApplyModule": "Mô-đun đã được áp dụng thành công",
    "font": "Phông chữ",
    "lineHeight": "Chiều cao dòng",
    "loadAutoServerBackup": "Tải sao lưu máy chủ tự động",
    "notCharxWarn": "Nhân vật này sử dụng nhiều tài sản. Nên xuất nhân vật này dưới dạng định dạng CharX để tương thích tốt hơn.",
    "noPlugins": "Không có plugin nào được cài đặt",
    "legacyTranslation": "Dịch cũ",
    "clipboardSuccess": "Đã sao chép vào bảng nhớ tạm",
    "translateContent": "Dịch nội dung",
    "doNotTranslate": "Không dịch",
    "includePersonaName": "Bao gồm tên Persona",
    "hidePersonaName": "Ẩn tên Persona",
    "triggerSwitchWarn": "Nếu bạn thay đổi loại trigger, các trigger hiện tại sẽ bị mất. Bạn có muốn tiếp tục không?",
    "codeMode": "Mã",
    "blockMode": "Khối",
    "helpBlock": "Trợ giúp",
    "hideChatIcon": "Ẩn giao diện biểu tượng",
    "loadInternalBackup": "Tải sao lưu nội bộ",
    "createCopy": "Tạo bản sao",
    "bindPersona": "Liên kết Persona",
    "chatOptions": "Tùy chọn trò chuyện",
    "doYouWantToBindCurrentPersona": "Bạn có muốn liên kết persona hiện tại vào cuộc trò chuyện này không?",
    "doYouWantToUnbindCurrentPersona": "Bạn có muốn hủy liên kết persona khỏi cuộc trò chuyện này không?",
    "personaBindedSuccess": "Persona đã được liên kết thành công",
    "personaUnbindedSuccess": "Persona đã được hủy liên kết thành công",
    "parameters": "Tham số",
    "sizeAndSpeed": "Kích thước và Tốc độ",
    "useLegacyGUI": "Sử dụng GUI cũ",
    "claudeCachingExperimental": "Lưu trữ đệm Claude",
    "openClose": "Mở/Đóng",
    "hideApiKeys": "Ẩn khóa API",
    "unformatQuotes": "Tắt định dạng trích dẫn",
    "enableDevTools": "Bật công cụ phát triển",
    "selectFile": "Chọn tập tin",
    "namespace": "Namespace",
    "moduleIntergration": "Tích hợp mô-đun",
    "previewInfo": "Bản xem trước này hiển thị lời nhắc trước khi xử lý theo mô hình cụ thể.",
    "miscTools": "Công cụ khác",
    "promptConvertion": "Chuyển đổi lời nhắc",
    "convertionStep1": "Chọn tất cả tập tin liên quan đến lời nhắc (Context, Instruct và Sampler JSON được hỗ trợ)",
    "customCSS": "CSS tùy chỉnh",
    "betaMobileGUI": "GUI di động Beta",
    "menu": "Menu",
    "jsonSchema": "JSON Schema",
    "enableJsonSchema": "Bật Schema",
    "strictJsonSchema": "Schema nghiêm ngặt",
    "extractJson": "Trích xuất JSON",
    "reloadSession": "Đã tìm thấy phiên bản dữ liệu lưu mới hơn. Đang tải lại phiên...",
    "fixMarkdownNewline": "Sửa lỗi xuống dòng Markdown",
    "customQuotes": "Dấu ngoặc kép tùy chỉnh",
    "leadingSingleQuote": "Dấu ngoặc đơn mở đầu",
    "leadingDoubleQuote": "Dấu ngoặc kép mở đầu",
    "trailingSingleQuote": "Dấu ngoặc đơn kết thúc",
    "trailingDoubleQuote": "Dấu ngoặc kép kết thúc",
    "translatorNote": "Ghi chú của người dịch",
    "formatGroupInSingle": "Định dạng nhóm trong đơn",
    "groupInnerFormat": "Định dạng nội bộ không phải người nói",
    "chatHTML": "HTML trò chuyện",
    "logShare": "Hiển thị nút chia sẻ nhật ký",
    "preview": "Xem trước",
    "recommended": "Được đề xuất",
    "newChat": "Cuộc trò chuyện mới",
    "predictedOutput": "Đầu ra dự đoán",
    "systemContentReplacement": "Thay thế nội dung hệ thống",
    "systemRoleReplacement": "Thay thế vai trò hệ thống",
    "seperateParameters": "Tham số riêng biệt",
    "seperateParametersEnabled": "Bật tham số riêng biệt",
    "summarizationPrompt": "Lời nhắc tóm tắt",
    "reSummarizationPrompt": "Lời nhắc tóm tắt lại",
    "translatorPrompt": "Lời nhắc dịch",
    "translateBeforeHTMLFormatting": "Dịch trước khi định dạng HTML",
    "retranslate": "Dịch lại",
    "editTranslation": "Chỉnh sửa bản dịch",
    "editTranslationSave": "Lưu bản dịch",
    "exportTranslationCache": "Xuất bộ nhớ đệm dịch",
    "exportTranslationCacheSuccess": "Đã xuất bộ nhớ đệm dịch thành công.",
    "importTranslationCache": "Nhập bộ nhớ đệm dịch",
    "importTranslationCacheConfirm": "Thao tác này sẽ hợp nhất các mục vào bộ nhớ đệm dịch thuật. Các khóa hiện có sẽ bị ghi đè. Tiếp tục?",
    "importTranslationCacheSuccess": "Đã nhập {0} mục bộ nhớ đệm dịch.",
    "importTranslationCacheFailed": "Đã nhập {0} mục, nhưng không thể lưu {1} mục. Bộ nhớ có thể đã đầy.",
    "exportTranslationCacheEmpty": "Bộ nhớ đệm dịch trống.",
    clearTranslationCache: "Xóa bộ nhớ đệm dịch thuật",
    clearTranslationCacheSuccess: "Đã xóa bộ nhớ đệm dịch thành công.",
    clearTranslationCacheConfirm: "Thao tác này sẽ xóa tất cả mục trong bộ nhớ đệm dịch thuật. Không thể hoàn tác. Tiếp tục?",
    "loading": "Đang tải",
    "autoTranslateCachedOnly": "Chỉ tự động dịch các tin nhắn đã lưu vào bộ nhớ đệm",
    "notification": "Thông báo",
    "permissionDenied": "Quyền bị từ chối bởi trình duyệt hoặc hệ điều hành của bạn",
    "customFlags": "Cờ tùy chỉnh",
    "enableCustomFlags": "Bật cờ tùy chỉnh",
    "googleCloudTokenization": "Tokenization Google Cloud",
    "presetChain": "Chuỗi cài đặt trước",
    "legacyMediaFindings": "Tìm kiếm phương tiện cũ",
    "staticsDisclaimer": "Thống kê dựa trên dữ liệu sau tháng 7 năm 2024. Dữ liệu có thể không chính xác.",
    "subtitles": "Phụ đề",
    "subtitlesWarning1": "Bạn phải sử dụng mô hình có đầu vào âm thanh/video để sử dụng tính năng này.",
    "subtitlesWarning2": "Bạn phải sử dụng mô hình có tính năng phát trực tuyến để sử dụng tính năng này.",
    "reset": "Đặt lại",
    "assetMaxDifference": "Sự khác biệt tối đa của tài sản",
    "sourceLanguage": "Ngôn ngữ nguồn",
    "destinationLanguage": "Ngôn ngữ đích",
    "noWebGPU": "Trình duyệt hoặc hệ điều hành của bạn không hỗ trợ WebGPU. Điều này sẽ làm chậm hiệu suất đáng kể.",
    "menuSideBar": "Thanh bên menu",
    "home": "Trang chủ",
    "showSavingIcon": "Hiển thị biểu tượng đang lưu",
    "pluginVersionWarn": "Đây là phiên bản {{plugin_version}} của plugin, không tương thích với phiên bản PocketRisu này. Vui lòng cập nhật plugin lên phiên bản {{required_version}}.",
    "imageTranslation": "Dịch hình ảnh",
    "banCharacterset": "Tự động tạo lại khi gặp bộ ký tự",
    "realmDirectOpen": "Mở trực tiếp nhân vật trong RisuRealm",
    "showPromptComparison": "Hiển thị so sánh lời nhắc",
    "inlayErrorResponse": "Phản hồi lỗi Inlay",
    "triggerOn": "Kích hoạt bật",
    "noConfig": "Không có cấu hình",
    "varName": "Tên biến",
    "var": "Biến",
    "condition": "Điều kiện",
    "trigger": "Trigger",
    "outputVar": "Biến đầu ra",
    "source": "Nguồn",
    "cmd": "Lệnh",
    "sysStart": "Hệ thống bắt đầu",
    "sysHistoryEnd": "Hệ thống kết thúc lịch sử",
    "sysPromptEnd": "Hệ thống kết thúc lời nhắc",
    "target": "Đích",
    "addElse": "Thêm Else",
    "min": "Tối thiểu",
    "max": "Tối đa",
    "delimiter": "Dấu phân cách",
    "deleteCount": "Số lượng xóa",
    "triggerEffRunAxLLM": "Chạy mô hình phụ trợ",
    "hypaV3Settings": {
        "descriptionLabel": "HypaMemory V3 là hệ thống bộ nhớ dài hạn sử dụng cả tóm tắt và tìm kiếm vector.",
        "supaMemoryPromptPlaceHolder": "Để trống để sử dụng giá trị mặc định",
        "maxMemoryTokensRatioLabel": "Tỷ lệ Token Bộ nhớ Tối đa (Ước tính)",
        "maxMemoryTokensRatioError": "Không thể tính toán Tỷ lệ Token Bộ nhớ Tối đa",
        "memoryTokensRatioLabel": "Tỷ lệ Token Bộ nhớ",
        "extraSummarizationRatioLabel": "Tỷ lệ Tóm tắt Bổ sung",
        "maxChatsPerSummaryLabel": "Số Tin nhắn Tối đa cho mỗi Tóm tắt",
        "recentMemoryRatioLabel": "Tỷ lệ Bộ nhớ Gần đây",
        "similarMemoryRatioLabel": "Tỷ lệ Bộ nhớ Tương tự",
        "randomMemoryRatioLabel": "Tỷ lệ Bộ nhớ Ngẫu nhiên",
        "enableSimilarityCorrectionLabel": "Bật Hiệu chỉnh Độ tương tự",
        "preserveOrphanedMemoryLabel": "Giữ Bộ nhớ Mồ côi",
        "applyRegexScriptWhenRerollingLabel": "Áp dụng Script Regex khi Tạo lại",
        "doNotSummarizeUserMessageLabel": "Không Tóm tắt Tin nhắn Người dùng"
    },
    "hypaV3Modal": {
        "titleLabel": "HypaV3",
        "resetConfirmMessage": "Hành động này không thể hoàn tác. Bạn có muốn đặt lại dữ liệu HypaV3 không?",
        "resetConfirmSecondMessage": "Hành động này không thể khôi phục. Bạn có thực sự chắc chắn muốn đặt lại dữ liệu HypaV3 không?",
        "convertLabel": "Chưa có tóm tắt nào, nhưng bạn có thể chuyển đổi dữ liệu HypaV2 sang V3.",
        "convertButton": "Chuyển đổi sang V3",
        "convertSuccessMessage": "Đã chuyển đổi thành công dữ liệu HypaV2 sang V3",
        "convertErrorMessage": "Chuyển đổi dữ liệu HypaV2 sang V3 thất bại: {0}",
        "noSummariesLabel": "Chưa có tóm tắt nào",
        "searchPlaceholder": "Nhập #N, ID hoặc từ khóa",
        "summaryNumberLabel": "Tóm tắt #{0}",
        "deleteThisConfirmMessage": "Xóa bản tóm tắt này?",
        "deleteAfterConfirmMessage": "Xóa tất cả các tóm tắt sau tóm tắt này?",
        "deleteAfterConfirmSecondMessage": "Hành động này không thể hoàn tác. Bạn có chắc chắn không?",
        "translationLabel": "Bản dịch",
        "rerolledSummaryLabel": "Tóm tắt đã Tạo lại",
        "rerolledTranslationLabel": "Bản dịch Tóm tắt đã Tạo lại",
        "connectedMessageCountLabel": "Tin nhắn Liên kết ({0})",
        "connectedFirstMessageLabel": "Tin nhắn Đầu tiên",
        "connectedMessageRoleLabel": "Tin nhắn của {0}",
        "connectedMessageNotFoundLabel": "Không tìm thấy tin nhắn",
        "connectedMessageLoadingError": "Lỗi khi tải tin nhắn liên kết: {0}",
        "connectedMessageTranslationLabel": "Bản dịch",
        "nextSummarizationFirstMessageLabel": "Tin nhắn Đầu tiên",
        "nextSummarizationNoMessageIdLabel": "Không có ID Tin nhắn",
        "nextSummarizationLabel": "HypaV3 sẽ tóm tắt [{0}]",
        "nextSummarizationNoMessagesFoundLabel": "CẢNH BÁO: Không tìm thấy tin nhắn",
        "nextSummarizationLoadingError": "Lỗi khi tải mục tiêu tóm tắt tiếp theo: {0}",
        "summarizationConditionLabel": "Mẹo: HypaV3 bắt đầu tóm tắt khi số lượng token đầu vào vượt quá kích thước ngữ cảnh tối đa.",
        "emptySelectedFirstMessageLabel": "CẢNH BÁO: Tin nhắn đầu tiên được chọn trống",
        "unclassified": "Chưa phân loại",
        "reSummarize": "Tóm tắt lại",
        "reSummarizing": "Đang tóm tắt lại...",
        "reSummarizeResult": "Kết quả tóm tắt lại",
        "retry": "Thử lại",
        "translate": "Dịch",
        "tag": "Thẻ",
        "tagManager": "Quản lý thẻ",
        "tagManagerTitle": "Quản lý thẻ - Tóm tắt #{0}",
        "newTagName": "Tên thẻ mới",
        "noTagsYet": "Chưa có thẻ nào.",
        "addNewTagHint": "Thêm thẻ mới ở trên.",
        "categoryManager": "Danh mục",
        "allCategories": "Tất cả",
        "categoryName": "Tên danh mục",
        "noCategoriesYet": "Chưa có danh mục nào.",
        "addNewCategoryHint": "Nhấp vào nút + ở trên để thêm một cái."
    },
    "bulkEnabling": "Bật hàng loạt Lorebook",
    "showTranslationLoading": "Hiển thị đang tải bản dịch",
    "showDeprecatedTriggerV1": "Hiển thị Trigger V1 đã lỗi thời",
    "showDeprecatedTriggerV2": "Hiển thị Trigger V2 đã lỗi thời",
    "triggerV1Warning": "Trigger V1 đã lỗi thời. Nó có thể bị xóa trong tương lai.",
    "copy": "Sao chép",
    "paste": "Dán",
    "depth": "Độ sâu",
    "returnCSSError": "Trả về lỗi CSS",
    "alwaysActiveInChat": "Luôn hoạt động (Trò chuyện hiện tại)",
    "childLoreDesc": "Đây là bản sao của cốt truyện nhân vật vẫn 'Luôn hoạt động' cho đến khi bị xóa hoặc tắt thủ công trong bản gốc.",
    "thinkingTokens": "Token suy nghĩ",
    "antiServerOverload": "Chống quá tải máy chủ",
    "localActivationInGlobalLorebook": "Kích hoạt cục bộ trong Lorebook toàn cầu",
    "cachePoint": "Điểm lưu trữ",
    "all": "Tất cả",
    "showFolderNameInIcon": "Hiển thị tên thư mục trong biểu tượng",
    "claudeCachingRetrival": "Truy xuất bộ nhớ đệm Claude",
    "claudeCachingRetrivalDesc": "Kéo dài thời gian lưu trữ bộ nhớ đệm Claude bằng cách yêu cầu mỗi 4 phút. Điều này có thể giảm tỷ lệ bỏ lỡ bộ nhớ đệm, nhưng có thể tăng chi phí nếu không sử dụng đúng cách.",
    "automaticCachePoint": "Điểm lưu trữ tự động",
    "experimentalChatCompression": "Xử lý dữ liệu trò chuyện thử nghiệm",
    "loadingChatData": "Đang tải dữ liệu trò chuyện",
    "outputImageModal": "Modal hình ảnh đầu ra",
    "playMessageOnTranslateEnd": "Phát âm thanh khi hoàn thành dịch",
    "auxModelUnderModelSettings": "Hiển thị tách biệt mô hình phụ trong cài đặt mô hình",
    "seperateModelsForAxModels": "Tách biệt mô hình cho các mô hình phụ trợ",
    "axModelsDef": "Định nghĩa mô hình Ax",
    "doNotChangeSeperateModels": "Không thay đổi mô hình tách biệt khi thay đổi cài đặt trước",
    "tools": "Công cụ",
    "action": "Hành động",
    "hotkey": "Phím nóng",
    "hotkeyDesc": {
        "reroll": "Tạo lại (Reroll)",
        "unreroll": "Hoàn tác tạo lại",
        "translate": "Dịch",
        "remove": "Xóa",
        "edit": "Chỉnh sửa",
        "copy": "Sao chép",
        "send": "Gửi",
        "settings": "Cài đặt",
        "home": "Trang chủ",
        "presets": "Chọn nhanh cài đặt trước",
        "persona": "Chọn nhanh Persona",
        "modelSelect": "Chọn nhanh mô hình",
        "toggleCSS": "Bật/Tắt CSS",
        "prevChar": "Nhân vật trước",
        "nextChar": "Nhân vật tiếp theo",
        "quickMenu": "Menu nhanh",
        "quickSettings": "Cài đặt nhanh",
        "toggleVoice": "Bật/Tắt giọng nói",
        "toggleLog": "Bật/Tắt nhật ký",
        "previewRequest": "Xem trước yêu cầu",
        "import": "Nhập",
        "export": "Xuất",
        "webcam": "Bật/Tắt Webcam",
        "focusInput": "Tập trung vào đầu vào",
        "scrollToActiveChar": "Cuộn đến nhân vật đang hoạt động"
    },
    "screenTooSmall": "Màn hình quá nhỏ để hiển thị giao diện.",
    "advancedModelSettings": "Cài đặt mô hình nâng cao",
    "fallbackModel": "Mô hình dự phòng",
    "fallbackWhenBlankResponse": "Dự phòng khi phản hồi trống",
    "doNotChangeFallbackModels": "Không thay đổi mô hình dự phòng khi thay đổi cài đặt trước",
    "customModels": "Mô hình tùy chỉnh",
    "igpPrompt": "Lời nhắc IGP",
    "useTokenizerCaching": "Lưu trữ đệm Tokenizer",
    "hypaMemoryV3Modal": "Hypa V3 Modal",
    "showMenuHypaMemoryModal": "Hiển thị Menu Hypa Modal",
    "promptInfoInsideChat": "Thêm thông tin lời nhắc vào trò chuyện",
    "promptTextInfoInsideChat": "Thêm văn bản lời nhắc vào trò chuyện",
    "promptInfoEmptyMessage": "Không có thông tin lời nhắc cho tin nhắn này.",
    "promptInfoEmptyToggle": "Không có chuyển đổi tùy chỉnh nào đang hoạt động.",
    "promptInfoEmptyText": "Chưa có văn bản lời nhắc nào được lưu.",
    "escapeOutput": "Thoát đầu ra",
    "claudeBatching": "Xử lý hàng loạt Claude",
    "claude1HourCaching": "Lưu trữ đệm Claude 1 giờ",
    "folderNameInput": "Vui lòng nhập tên thư mục mới",
    "folderRemoveLengthError": "Để xóa thư mục, nó phải không chứa bất kỳ mục nào.",
    "personaNote": "Ghi chú Persona",
    "mcpAccessPrompt": "{{tool}} đang cố gắng \"{{action}}\". Bạn có muốn cho phép điều này không?",
    "rememberToolUsage": "Ghi nhớ việc sử dụng công cụ",
    "simplifiedToolUse": "Sử dụng công cụ đơn giản hóa",
    "toolCalled": "Công cụ '{{tool}}' đã được gọi",
    "static": "Tĩnh",
    "dynamic": "Động",
    "assetStyle": "Phong cách tài sản",
    "insertAssetPrompt": "Chèn lời nhắc tài sản",
    "requestLocation": "Yêu cầu vị trí",
    "newImageHandlingBeta": "Xử lý hình ảnh mới (Beta)",
    "settingsExported": "Cài đặt báo cáo lỗi đã được xuất và sao chép vào bảng nhớ tạm.",
    "bookmarks": "Dấu trang",
    "noBookmarks": "Không có dấu trang",
    "bookmarkAskNameOrDefault": "Nhập tên dấu trang. Nếu không nhập, nó sẽ được gán tự động.",
    "bookmarkAskNameOrCancel": "Nhập tên dấu trang. Nếu không nhập, việc đổi tên sẽ bị hủy.",
    "collapseAll": "Thu gọn tất cả",
    "expandAll": "Mở rộng tất cả",
    "hideErrorDetails": "Ẩn chi tiết lỗi",
    "showErrorDetails": "Hiển thị chi tiết lỗi",
    "dynamicOutput": "Đầu ra động",
    "autoAdjustSchema": "Tự động điều chỉnh Schema",
    "dynamicMessages": "Tin nhắn động",
    "dynamicMemory": "Bộ nhớ động",
    "dynamicResponseTiming": "Thời gian phản hồi động",
    "showTypingEffect": "Hiển thị hiệu ứng gõ",
    "dynamicRequest": "Yêu cầu động",
    "dynamicOutputPrompt": "Lời nhắc đầu ra động",
    "settingsCloseButtonSize": "Kích thước nút đóng cài đặt",
    "translating": "Đang dịch...",
    "stackTraceTranslationFailed": "Dịch dấu vết ngăn xếp thất bại. Hiển thị dấu vết ngăn xếp bị làm rối ban đầu bên dưới.",
    "translate": "Dịch địa chỉ mã",
    "apply": "Áp dụng",
    "add": "Thêm",
    "nightlyWarning": "## Bản dựng Nightly\n\nBạn đang kết nối với bản dựng Nightly của phần mềm. Phiên bản này dùng để thử nghiệm và rất có thể có lỗi. **Trong phiên bản này, ngay cả khi bạn gặp sự cố, chúng tôi không hỗ trợ giải quyết trực tiếp.**",
    "loginSionyw": "Đăng nhập bằng tài khoản Sionyw",
    "pluginRiskDetectedAlert": "PocketRisu phát hiện mã có thể gây hại, có thể ĂN CẮP KHÓA API HOẶC DỮ LIỆU CÁ NHÂN CỦA BẠN. Chúng tôi khuyên bạn KHÔNG NÊN CÀI ĐẶT PLUGIN NÀY.",
    "doNotInstall": "Không cài đặt",
    "continueAnyway": "Vẫn tiếp tục",
    "pluginNoRiskButAlert": "PocketRisu không phát hiện mã độc hại, nhưng xin lưu ý rằng việc cài đặt plugin từ các nguồn không tin cậy có thể gây rủi ro bảo mật.",
    "pluginRisksInuserFriendly": {
        "eval": "Đánh giá mã từ chuỗi",
        "globalAccess": "Truy cập biến toàn cục",
        "thisOutsideClass": "Sử dụng 'this' bên ngoài ngữ cảnh lớp",
        "errorInVerification": "Lỗi trong quá trình xác minh",
        "storageAccess": "Truy cập bộ nhớ"
    },
    "pluginRisksInuserFriendlyDesc": {
        "eval": "Plugin cố gắng thực thi mã từ chuỗi, chuỗi có thể bị làm mờ để ẩn mã độc hại.",
        "globalAccess": "Plugin cố gắng truy cập các biến toàn cục, điều này có thể dẫn đến các tác dụng phụ không mong muốn hoặc lỗ hổng bảo mật.",
        "thisOutsideClass": "Plugin sử dụng từ khóa 'this' bên ngoài ngữ cảnh lớp, điều này có thể dẫn đến hành vi không mong muốn hoặc các vấn đề bảo mật.",
        "errorInVerification": "Có lỗi trong quá trình xác minh plugin, cho thấy các vấn đề tiềm ẩn với chức năng của nó.",
        "storageAccess": "Plugin cố gắng truy cập bộ nhớ, điều này có thể dẫn đến rò rỉ dữ liệu hoặc thao tác dữ liệu trái phép."
    },
    "generatedByAIDisclaimer": "Nội dung này được tạo bởi AI và có thể chứa thông tin không chính xác hoặc thiên kiến.",
    "aiGenerationWarning": "Nội dung sẽ được tạo bởi AI và có thể chứa thông tin không chính xác hoặc thiên kiến.",
    "noRequestLogs": "Không có nhật ký yêu cầu nào.",
    "bookmark": "Dấu trang",
    "duplicatePluginFoundUpdateIt": "Phát hiện plugin trùng lặp. Bạn có muốn cập nhật plugin hiện có không?",
    "pluginUpdateFoundInstallIt": "Đã tìm thấy bản cập nhật plugin. Bạn có muốn cài đặt bản cập nhật này không?",
    "branchedText": "Cuộc trò chuyện này đã được rẽ nhánh từ {}.",
    "loadMore": "Tải thêm",
    "goToChat": "Đi đến Chat",
    "branch": "Chi nhánh",
    "newMessage": "Tin nhắn mới",
    "autoScrollToNewMessage": "Tự động cuộn đến tin nhắn mới",
    "alwaysScrollToNewMessage": "Luôn cuộn đến tin nhắn mới (bỏ qua vị trí cuộn)",
    "newMessageButtonStyle": "Kiểu nút tin nhắn mới",
    "disableAbove": "Cắt tin nhắn cho AI",
    "newMessageButtonBottomRight": "Dưới cùng bên phải",
    "disableMessage": "Vô hiệu hóa tin nhắn",
    "newMessageButtonFloatingCircle": "Vòng tròn nổi (Góc dưới bên phải)",
    "newMessageButtonBottomLeft": "Phía dưới bên trái",
    "newMessageButtonBottomCenter": "Dưới cùng ở giữa (Mặc định)",
    "fetchLogConsent": "Plugin {} đang yêu cầu truy xuất nhật ký, hành động này có thể làm lộ thông tin nhạy cảm. Bạn có muốn cho phép điều này không?",
    "newMessageButtonTopBar": "Thanh trên cùng",
    "pluginDevelopMode": "Chế độ phát triển Plugin",
    "mainDomAccessConsent": "Plugin {} đang yêu cầu truy cập vào Tài liệu chính, điều này có thể làm lộ thông tin nhạy cảm. Bạn có muốn cho phép không?",
    "getFullDatabaseConsent": "Plugin {} đang yêu cầu truy cập vào toàn bộ cơ sở dữ liệu, điều này có thể làm lộ thông tin nhạy cảm. Bạn có muốn cho phép điều này không?",
    "replacerPermissionConsent": "Plugin {} đang yêu cầu quyền thay thế nội dung trong cuộc trò chuyện, điều này có thể được sử dụng để thao túng cuộc đối thoại. Bạn có muốn cho phép không?",
    "providerPermissionConsent": "Plugin {} đang yêu cầu quyền truy cập Provider, điều này có thể cho phép nó thực hiện các lệnh gọi API trái phép. Bạn có muốn cho phép không?",
    "sendChatConsent": "Plugin {} đang yêu cầu quyền gửi tin nhắn trò chuyện thay mặt bạn, điều này sẽ kích hoạt phản hồi AI. Bạn có muốn cho phép không?",
    "pluginV2Warning": "Plugin V2 và V2.1 bị coi là không an toàn và sẽ ngừng hoạt động trong các phiên bản sau. **Vui lòng không sử dụng các phiên bản plugin này.** Nếu bạn là nhà phát triển của plugin này, vui lòng cập nhật lên V3 càng sớm càng tốt.",
    "enableScrollToActiveChar": "Bật cuộn đến nhân vật đang hoạt động",
    "trimStartNewChat": "Rút gọn các tin nhắn 'Bắt đầu đoạn chat mới'",
    "newMessageButtonRightCenter": "Trung tâm bên phải",
    "hamburgerButtonBottom": "Di chuyển nút menu xuống dưới cùng của thanh bên",
    "nanoGPTLoadingAccountInfo": "Đang tải thông tin tài khoản…",
    "nanoGPTCreditBalance": "Số dư tín dụng:",
    "nanoGPTSubscription": "Đăng ký",
    "nanoGPTGraceUntil": (date: string) => `đến ${date}`,
    "nanoGPTNoActiveSubscription": "Không có đăng ký đang hoạt động.",
    "nanoGPTCancelsAtPeriodEnd": (date: string) => `Hủy vào cuối kỳ (${date})`,
    "nanoGPTWeeklyTokens": (pct: string) => `Token đầu vào hàng tuần — đã dùng ${pct}`,
    "nanoGPTDailyTokens": (pct: string) => `Token đầu vào hàng ngày — đã dùng ${pct}`,
    "nanoGPTDailyImages": (pct: string) => `Hình ảnh hàng ngày — đã dùng ${pct}`,
    "nanoGPTResets": (date: string) => `Đặt lại vào ${date}`,
    "nanoGPTUsed": (n: string) => `Đã dùng ${n}`,
    "nanoGPTRemaining": (n: string) => `Còn lại ${n}`,
    "nanoGPTRenews": (date: string) => `Gia hạn: ${date}`,
    "nanoGPTCouldNotLoadAccountInfo": "Không thể tải thông tin tài khoản.",
    "nanoGPTWeeklyTokensLabel": "Token đầu vào hàng tuần",
    "nanoGPTDailyTokensLabel": "Token đầu vào hàng ngày",
    "nanoGPTDailyImagesLabel": "Hình ảnh hàng ngày",
    "nanoGPTUsedLabel": "đã dùng",
    "nanoGPTRemainingLabel": "còn lại",
    "nanoGPTResetsLabel": "Đặt lại",
    "nanoGPTRenewsLabel": "Gia hạn:",
    "nanoGPTProvider": "Nhà cung cấp",
    "nanoGPTProviderPayAsYouGoOnly": "(chỉ khả dụng ở chế độ trả theo lượng dùng)",
    "nanoGPTProviderAuto": "Tự động",
    "nanoGPTProviderFree": "Miễn phí",
    "nanoGPTProviderInput": "Đầu vào",
    "nanoGPTProviderOutput": "Đầu ra",
    "nanoGPTProviderQuantization": "Lượng tử hóa",
    "nanoGPTProviderUndisclosed": "Chưa công bố",
    "nanoGPTProviderCache": "Bộ nhớ đệm",
    "nanoGPTProviderCacheSupported": "Hỗ trợ",
    "nanoGPTProviderCacheNotSupported": "Không hỗ trợ",
    "nanoGPTProviderCacheRead": "Đọc bộ nhớ đệm",
    "nanoGPTUseSubscriptionEndpoint": "Sử dụng endpoint và mô hình đăng ký",
    "modelGridCouldNotLoad": "Không thể tải danh sách mô hình. Kiểm tra khóa API của bạn.",
    "modelGridNoModelsMatch": (q: string) => `Không có mô hình nào khớp với "${q}"`,
    "modelGridContext": (n: string) => `Ngữ cảnh: ${n}`,

    nanoGPTSelectFromList: "Chọn từ danh sách",
    nanoGPTManualInput: "Nhập thủ công",
    nanoGPTManualModelSelect: "Chọn mô hình thủ công",

    remoteAccessTermuxWarning: "Cloudflare Quick Tunnel không hoạt động trên Termux. Hãy sử dụng Tailscale hoặc công cụ truy cập từ xa khác.",

    httpInsecureWarningTitle: "Đang kết nối qua HTTP",
    httpInsecureWarningBody: "Một số tính năng như plugin có thể không hoạt động. Hãy dùng tính năng Truy cập từ xa để có kết nối HTTPS.",
    httpInsecureOpenRemoteAccess: "Mở cài đặt",

    selectBotHint: "Chọn một bot để bắt đầu trò chuyện",
} satisfies DeepPartial<typeof import('./en').languageEnglish>;
